import {takeLatest} from "redux-saga";
import {fork, put, take} from "redux-saga/effects";
import {generateUUID} from "../lib/UUID";
import * as OnboardingApiActions from "../actions/OnboardingApiActions";
import {
  showModalWindow,
  removeModalWindow
  } from "../actions/WindowActions";
// Handle GUI for assigning warehouse to an order.
function* requestChangePassword(baseAction) {
  let windowId = generateUUID();
  yield put(showModalWindow(windowId, "ChangeOnboardingPasswordWindow", {customerId: baseAction.customerId}, "Change Password"));
  yield take([OnboardingApiActions.CHANGE_PASSWORD.CANCEL, OnboardingApiActions.CHANGE_PASSWORD.SUCCESS]);
  yield put(removeModalWindow(windowId));
}
function* watchRequestChangePassword() {
  yield takeLatest(OnboardingApiActions.REQUEST_CHANGE_PASSWORD, requestChangePassword);
}

function* requestInviteCustomer(baseAction) {
  let windowId = generateUUID();
  yield put(showModalWindow(windowId, "InviteCustomerWindow", {customerId: baseAction.customerId}, "Invite Customer"));
  yield take([OnboardingApiActions.INVITE_CUSTOMER.CANCEL, OnboardingApiActions.INVITE_CUSTOMER.SUCCESS]);
  yield put(removeModalWindow(windowId));
}
function* watchRequestInviteCustomer() {
  yield takeLatest(OnboardingApiActions.REQUEST_INVITE_CUSTOMER, requestInviteCustomer);
}


export default function* saga() {
  yield fork(watchRequestChangePassword);
  yield fork(watchRequestInviteCustomer);
 }